import { UIField } from "../../../models/UIField";

export const ComboboxField = ({ model, list, readonly, maxChars }: { model: UIField; list?: string; readonly?: boolean; maxChars?: number }) => {
  return (
    <div className="flex h-7 items-center">
      <label title={model.description}>{model.label}</label>
      <input
        type="text"
        className={`ml-auto w-3/5 h-full px-2 rounded border-2 ${!readonly ? "text-black" : "bg-transparent text-white"}`}
        list={list}
        readOnly={readonly}
        value={model.value}
        onInput={(e) => {
          const text = e.currentTarget.value;
          model.setValue(maxChars ? text.substring(0, maxChars) : text);
        }}
      />
    </div>
  );
};
